

















import { Component, Vue } from 'vue-property-decorator';
import HeaderMenu from '../../components/headermenu.vue';

@Component({
  components: { HeaderMenu },
})
export default class FlightPayment extends Vue {
  birthday: Date = null;
  radios: boolean = true;
  radios1: boolean = true;
  radios2: boolean = true;
  radios3: boolean = true;

  data() {
    return {};
  }
}
